import { render } from "./replace.vue?vue&type=template&id=4c2e507f"
import script from "./replace.vue?vue&type=script&lang=js"
export * from "./replace.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__